import { fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import CpPanel from 'ember-collapsible-panel/components/cp-panel/component';
import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { not, or } from 'ember-truth-helpers';

import Button from 'umg-ember-backend/components/ui/button';
import Form from 'umg-ember-backend/components/ui/form';
import InfoBox from 'umg-ember-backend/components/ui/info-box';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

interface SftpUserSignature {
  Args: {
    user: TODO;
    generateNewPassword: (user: TODO) => void;
    saveSftpUser: (user: TODO) => void;
  };
  Blocks: {
    default: [];
  };
}

export default class SftpUserComponent extends Component<SftpUserSignature> {
  // Services
  @service declare recordStatus: TODO;

  // Getter and setter
  get isUserDisabledOrInvalid() {
    return this.recordStatus.isDisabledOrInvalid(this.args.user);
  }

  // Template
  <template>
    <Form @disableRegisterToBreadcrumb={{true}} @model={{@user}} as |form|>
      <CpPanel as |panel|>
        <div class={{(bem)}}>
          <panel.toggle>
            <div
              class={{bem
                'header'
                (hash is-user-invalid=form.model.isUserInvalid)
              }}
              data-test-ui-sftp-user-header
            >
              <span class={{bem 'icon'}}>
                {{#if form.model.isUserValid}}
                  {{svgJar 'success' class='u-icon'}}
                {{else}}
                  {{svgJar 'error' class='u-icon'}}
                {{/if}}
              </span>
              {{form.model.userDisplayLabel}}
            </div>
          </panel.toggle>

          <panel.body>
            {{#if form.model.isExpired}}
              <InfoBox @type='warning'>
                {{t 'sftp_user.expired'}}
              </InfoBox>
            {{else if form.model.isPasswordInvalid}}
              <InfoBox @type='warning'>
                {{t 'sftp_user.invalid_password'}}
              </InfoBox>
              <Button
                @disabled={{or
                  this.isUserDisabledOrInvalid
                  (not form.hasPermissionToEdit)
                }}
                @icon='refresh'
                @label={{t 'sftp_user.generate_new_password'}}
                {{on 'click' (fn @generateNewPassword form.model)}}
              />
            {{else}}
              <label>{{t 'sftp_user.accessData'}}</label><br />
              {{t 'sftp_user.path'}}
              {{form.model.homedir}}<br />
              {{t 'sftp_user.host'}}<br />
              {{t 'sftp_user.username'}}
              {{form.model.username}}<br />
              {{t 'sftp_user.password'}}
              {{form.model.password}}<br /><br />

              <div class={{bem 'purpose'}}>
                <div class={{bem 'field'}}>
                  <form.field @property='purpose' />
                </div>
                <div class={{bem 'button'}}>
                  <Button
                    disabled={{or
                      this.isUserDisabledOrInvalid
                      (not form.hasPermissionToEdit)
                    }}
                    @label={{t 'sftp_user.save'}}
                    {{on 'click' (fn @saveSftpUser form.model)}}
                  />
                </div>
              </div>
            {{/if}}
          </panel.body>
        </div>
      </CpPanel>
    </Form>
  </template>
}
